import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './_styles_/Lng.css';
import { onActionKey } from '../utils';

Lng.propTypes = {
    lng: PropTypes.string.isRequired,
};

function Lng(props) {
    const { lng } = props;
    const { i18n } = useTranslation();
    const changeLanguageHandler = () => i18n.changeLanguage(lng);
    return (
        <span className={`lng-item${i18n.language === lng ? ' active' : ''}`} onClick={changeLanguageHandler} onKeyUp={onActionKey(changeLanguageHandler)} role="button" tabIndex={0}>{lng}</span>
    );
}

export default Lng;
